export const camelCaseToTitleCase = (camelCase) => {
	const result = camelCase.replace(/([A-Z])/g, " $1");
	return result.charAt(0).toUpperCase() + result.slice(1);
};
